/** How big the breathing ring is at each end of a breath: full on the inhale, small on the exhale. */
export const BREATH_SCALE = { in: 1, out: 0.55 } as const;
